import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

const BacktestContext = createContext(null);

/**
 * Shares backtest results with the chart (trade markers) and the Backtest panel.
 */
export function BacktestProvider({ children }) {
  const [results, setResults] = useState(null);
  const [showMarkers, setShowMarkers] = useState(true);
  const [lastRunMeta, setLastRunMeta] = useState(null);

  const clearResults = useCallback(() => {
    setResults(null);
    setLastRunMeta(null);
  }, []);

  const value = useMemo(
    () => ({
      results,
      setResults,
      showMarkers,
      setShowMarkers,
      lastRunMeta,
      setLastRunMeta,
      clearResults,
    }),
    [results, showMarkers, lastRunMeta, clearResults]
  );

  return <BacktestContext.Provider value={value}>{children}</BacktestContext.Provider>;
}

export function useBacktest() {
  const ctx = useContext(BacktestContext);
  if (!ctx) {
    return {
      results: null,
      setResults: () => {},
      showMarkers: false,
      setShowMarkers: () => {},
      lastRunMeta: null,
      setLastRunMeta: () => {},
      clearResults: () => {},
    };
  }
  return ctx;
}

export default BacktestContext;
